import { render, staticRenderFns } from "./SkeletonPlan.vue?vue&type=template&id=70062d28&scoped=true"
import script from "./SkeletonPlan.vue?vue&type=script&lang=js"
export * from "./SkeletonPlan.vue?vue&type=script&lang=js"
import style0 from "./SkeletonPlan.vue?vue&type=style&index=0&id=70062d28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.42_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_etfl7lgzzfti5tuwpbu7orzhm4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70062d28",
  null
  
)

export default component.exports